import React, { useState } from 'react';
import './PasswordInput.css';

export function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder = '••••••••',
  required = false,
  disabled = false,
  autoComplete = 'current-password',
  ariaDescribedBy,
  ariaInvalid,
}) {
  const [visible, setVisible] = useState(false);
  const [capsLockOn, setCapsLockOn] = useState(false);
  const [focused, setFocused] = useState(false);

  const updateCapsLock = (e) => {
    if (typeof e.getModifierState === 'function') {
      setCapsLockOn(e.getModifierState('CapsLock'));
    }
  };

  const showCapsWarning = focused && capsLockOn;
  // Compose aria-describedby so callers' hint id still works alongside the warning.
  const describedBy = [ariaDescribedBy, showCapsWarning ? `${id}-caps`  : null]
    .filter(Boolean)
    .join(' ') || undefined;

  return (
    <div className="password-input-wrap">
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid || undefined}
        onKeyDown={updateCapsLock}
        onKeyUp={updateCapsLock}
        onFocus={(e) => { setFocused(true); updateCapsLock(e); }}
        onBlur={() => setFocused(false)}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        tabIndex={0}
      >
        {visible ? 'Hide' : 'Show'}
      </button>
      {showCapsWarning && (
        <small
          id={`${id}-caps`}
          className="password-caps-warning"
          role="status"
        >
          Caps Lock is on
        </small>
      )}
    </div>
  );
}
